import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × LE LABO: Scent as data
// Amber gradients, laboratory grids, typewritten labels
export function VasarelyLelaboMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="lelabo-amber1" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#8B4513" />
          <stop offset="50%" stopColor="#A0522D" />
          <stop offset="100%" stopColor="#CD853F" />
        </linearGradient>
        <linearGradient id="lelabo-amber2" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#CD853F" />
          <stop offset="50%" stopColor="#DEB887" />
          <stop offset="100%" stopColor="#F5DEB3" />
        </linearGradient>
        <radialGradient id="lelabo-diffusion">
          <stop offset="0%" stopColor="#F5DEB3" stopOpacity="0.6" />
          <stop offset="50%" stopColor="#DEB887" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#CD853F" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Laboratory beige background */}
      <rect x="0" y="0" width="794" height="1123" fill="#F5F1E8" />

      <g transform="translate(397 540)">
        {/* Laboratory grids */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 22 }).map((_, j) => {
            const x = (i - 7.5) * 48;
            const y = (j - 10.5) * 48;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 22}
                y={y - 22}
                width="44"
                height="44"
                fill="none"
                stroke="#A0522D"
                strokeWidth="0.5"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Scent diffusion circles */}
        {Array.from({ length: 15 }).map((_, i) => {
          const r = 30 + i * 20;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="url(#lelabo-diffusion)"
              opacity={0.15 - i * 0.008}
            />
          );
        })}

        {/* Olfactory geometry waves */}
        {Array.from({ length: 12 }).map((_, i) => {
          const offset = i * 30;
          return (
            <path
              key={i}
              d={`M ${-300 + offset} ${-300} Q ${offset} ${0} ${-300 + offset} ${300}`}
              fill="none"
              stroke="url(#lelabo-amber1)"
              strokeWidth="1"
              opacity={0.2 - i * 0.012}
            />
          );
        })}

        {/* Typewritten label grid */}
        {[
          { x: -150, y: -200, label: "SANTAL 33" },
          { x: -150, y: -100, label: "ROSE 31" },
          { x: -150, y: 0, label: "BERGAMOTE 22" },
          { x: -150, y: 100, label: "NEROLI 36" },
          { x: -150, y: 200, label: "THE NOIR 29" },
        ].map((item, i) => (
          <g key={i}>
            <rect
              x={item.x}
              y={item.y - 15}
              width="300"
              height="30"
              fill="none"
              stroke="#8B4513"
              strokeWidth="1"
              opacity="0.3"
            />
            <text
              x={item.x + 10}
              y={item.y + 5}
              fontFamily="Courier, monospace"
              fontSize="9"
              fill="#8B4513"
              opacity="0.6"
            >
              {item.label}
            </text>
          </g>
        ))}

        {/* Central amber vortex */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          const r1 = 60;
          const r2 = 120;
          
          return (
            <line
              key={i}
              x1={Math.cos(angle) * r1}
              y1={Math.sin(angle) * r1}
              x2={Math.cos(angle) * r2}
              y2={Math.sin(angle) * r2}
              stroke="url(#lelabo-amber2)"
              strokeWidth="2"
              opacity="0.4"
            />
          );
        })}

        <circle cx="0" cy="0" r="60" fill="url(#lelabo-amber1)" opacity="0.3" />
        <circle cx="0" cy="0" r="40" fill="url(#lelabo-amber2)" opacity="0.4" />
        <circle cx="0" cy="0" r="20" fill="#8B4513" opacity="0.5" />
      </g>

      {/* Typewritten signature */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="Courier, monospace" fontSize="9" fill="#8B4513" letterSpacing="2">
        SCENT AS DATA
      </text>
    </g>
  );
}
